import { HSLColor } from './hsl-color';

export class ColorService {

    private static colorList: HSLColor[] = [];

    static getRandomPastelColor() {
        return "hsl(" + 360 * Math.random() + ',' +
            (25 + 70 * Math.random()) + '%,' +
            (85 + 10 * Math.random()) + '%)'
    }
    
    static getNewColor(range: number) {

        const color = new HSLColor();
        if (ColorService.colorList .length === 0) {
            color.H = Math.floor(Math.random() * 360);
        } else {
            color.H = (ColorService.colorList[ColorService.colorList.length - 1].H + Math.round(360 / range)) % 360;
        }

        color.S = Math.floor(Math.random() * (50 - 30) + 30);
        color.L = 80;

        ColorService.colorList.push(color);
        return color;
    }

    static getNewColorWithFlush(range: number) {
        ColorService.colorList = [];
        return this.getNewColor(range);
    }

    static getDarkerColorFromExisting(color: HSLColor) {
        const darkerColor = new HSLColor();
        darkerColor.H = color.H;
        darkerColor.S = color.S;
        darkerColor.L = color.L - 20;
        return darkerColor;
    }
}
